import { Component, ElementRef, Input, OnInit, OnDestroy, HostListener, EventEmitter, Output } from '@angular/core';
import { ModalController, PopoverController } from '@ionic/angular';
import { CommentsModalComponent } from '../../../comments/comments-modal/comments-modal.component';
import { PublicationService } from 'src/app/services/publications/publication.service';
import { ReactionssService } from 'src/app/services/reactions/reactions.service';
import { PublicationClass } from 'src/app/Models/Classes/Publications/publication-class';
import { ModalTransactionComponent } from '../../../single-elements/modal-transaction/modal-transaction.component';
import { PagoTarjetaComponent } from 'src/app/components/pago-verificacion/Pago-Tarjeta/Pago-Tarjeta.component';
import { MetodoDePagoComponent } from './../../../create/finalizar-compra/metodo-de-pago/metodo-de-pago.component';
import { VerDetallesComponent } from './../../../create/Ver-detalles/Ver-detalles.component';
import { PagosPorPublicacionComponent } from '../../../create/Pagos/Pagos-por-publicacion/Pagos-por-publicacion.component';
import { runInThisContext } from 'vm';
import { NormalPublication } from 'src/app/Models/Classes/Publications/Normal/normal-publication';
import {FormServiceService} from "src/app/services/publications/form-service.service";
import { RequestService } from 'src/app/services/request/request.service';
import Swal2 from 'sweetalert2';
import { SocialInteractionNotificationService } from 'src/app/services/notifications/social-interaction-notification.service';
import { Capacitor } from '@capacitor/core';
import { NativeLiquidGlass } from 'src/app/plugins/native-runtime.plugins';

@Component({
  selector: 'app-information',
  templateUrl: './information.component.html',
  styleUrls: ['./information.component.scss'],
})

export class InformationComponent implements OnInit, OnDestroy {
  interval;
  originalDescription;
  originalTitle;
  @Input() publication: any;
  @Input() corp: boolean = false;
  @Output() savePublication = new EventEmitter();
  @Output() success = new EventEmitter();
	@Input() profilePhoto: string;
  @Input() activeSlideIndex: number;
  @Input() currentSlideIndex: number;
  private nativeInformationState = '';
  // Suppress every repeated Angular information instance immediately on iOS.
  // The active instance will turn this off only if native glass is unavailable.
  public nativeInformationAvailable = Capacitor.getPlatform() === 'ios';
  activador:boolean=false
  public showMore = true;
  public planetRequestLoading = false;
  public postIntelPopover = {
    visible: false,
    loading: false,
    asking: false,
    x: 12,
    y: 12,
    title: '',
    summary: '',
    question: '',
  };

  constructor(private modalController: ModalController,private popOvercontroller: PopoverController,   public formService: FormServiceService,
    private request: RequestService,
    private socialNotifications: SocialInteractionNotificationService,
    private elementRef: ElementRef<HTMLElement>,
    ) { }

    ngOnInit() {
     
      console.log('Publication in InformationComponent:', this.publication);
      if (this.publication) {
        console.log('Publication title in InformationComponent:', this.publication.title);
        console.log('Publication views in InformationComponent:', this.publication.views);

      }
    }

    ngDoCheck(): void {
      this.syncNativeInformation();
    }

    ngOnDestroy(): void {
      if (this.isNativePublicationSurfaceEligible() && Capacitor.getPlatform() === 'ios') {
        document.body.classList.remove('native-publication-info');
        NativeLiquidGlass.setPublicationInfoSuppressed({ suppressed: true }).catch(() => undefined);
        NativeLiquidGlass.setRegion({ region: 'publication-info', visible: false, suppressed: true }).catch(() => undefined);
      }
      this.nativeInformationAvailable = false;
    }

    private isActivePublication(): boolean {
      return Number.isFinite(Number(this.activeSlideIndex))
        && Number(this.activeSlideIndex) === Number(this.currentSlideIndex);
    }

  private syncNativeInformation(): void {
      if (Capacitor.getPlatform() !== 'ios' || !this.isNativePublicationSurfaceEligible()) return;
      const title = String(this.publication?.title || '');
      const description = String(this.publication?.description || '');
      const username = this.authorUsername;
      const verified = this.publication?.Verified === true;
      const postedAgo = this.publicationPostedAgo;
      const expanded = this.formService.showMoreHidden !== true;
      const price = Number(this.publication?.price) || 0;
      const scrubberGeometry = this.currentScrubberGeometry();
      const state = JSON.stringify({ title, description, username, verified, postedAgo, expanded, price, ...scrubberGeometry });
      if (this.nativeInformationState === state) return;
      this.nativeInformationState = state;
      NativeLiquidGlass.setPublicationInfoSuppressed({ suppressed: false }).catch(() => undefined);
      NativeLiquidGlass.setRegion({ region: 'publication-info', visible: true, suppressed: false, title, description, username, verified, postedAgo, expanded, price, ...scrubberGeometry })
        .then(({ available }) => {
          this.nativeInformationAvailable = available;
          document.body.classList.toggle('native-publication-info', available);
        })
        .catch(() => {
          this.nativeInformationAvailable = false;
          document.body.classList.remove('native-publication-info');
        });
    }

    private currentScrubberGeometry(): { scrubberVisible: boolean; scrubberTop?: number; webViewHeight?: number } {
      const slide = this.elementRef.nativeElement.closest<HTMLElement>('ion-slide');
      const scrubber = slide?.querySelector<HTMLElement>('.video-scrubber-shell');
      const bounds = scrubber?.getBoundingClientRect();
      if (!bounds || bounds.width <= 0 || bounds.height <= 0) return { scrubberVisible: false };
      return { scrubberVisible: true, scrubberTop: bounds.top, webViewHeight: window.innerHeight };
    }

    get authorUsername(): string {
      return String(this.publication?.userProfile?.username || this.publication?.owner || this.publication?.username || 'Laniakea');
    }

    get publicationPostedAgo(): string {
      const timestamp = this.publicationTimestamp();
      if (!timestamp) return '';
      const seconds = Math.max(0, Math.floor((Date.now() - timestamp) / 1000));
      if (seconds < 60) return 'ahora';
      const minutes = Math.floor(seconds / 60);
      if (minutes < 60) return `hace ${minutes} min`;
      const hours = Math.floor(minutes / 60);
      if (hours < 24) return `hace ${hours} h`;
      const days = Math.floor(hours / 24);
      return `hace ${days} día${days === 1 ? '' : 's'}`;
    }

    private publicationTimestamp(): number | null {
      const values = [
        this.publication?.createdAt,
        this.publication?.created_at,
        this.publication?.container?.createdAt,
        this.publication?.container?.created_at,
      ];
      for (const value of values) {
        const numeric = typeof value === 'number' || (typeof value === 'string' && /^\d+(?:\.\d+)?$/.test(value.trim()))
          ? Number(value)
          : NaN;
        const timestamp = Number.isFinite(numeric)
          ? (numeric > 0 && numeric < 100000000000 ? numeric * 1000 : numeric)
          : new Date(value as any).getTime();
        if (Number.isFinite(timestamp) && timestamp >= 946684800000) return timestamp;
      }
      return null;
    }

    private isNativePublicationSurfaceEligible(): boolean {
      if (!this.isActivePublication()
        || document.body.classList.contains('native-publication-overlay-suspended')) {
        return false;
      }
      const host = this.elementRef.nativeElement;
      if (!host?.isConnected) return false;
      const hiddenPage = host.closest('.ion-page-hidden, [aria-hidden="true"]');
      if (hiddenPage) return false;
      const publicationTemplate = host.closest('app-publication-media-template') as HTMLElement | null;
      if (!publicationTemplate) return false;
      const style = getComputedStyle(publicationTemplate);
      const bounds = publicationTemplate.getBoundingClientRect();
      return style.display !== 'none'
        && style.visibility !== 'hidden'
        && bounds.width > 0
        && bounds.height > 0;
    }

    @HostListener('window:nativePublicationContextRestored')
    handleNativePublicationContextRestored(): void {
      if (Capacitor.getPlatform() !== 'ios' || !this.isNativePublicationSurfaceEligible()) return;
      this.nativeInformationState = '';
      this.syncNativeInformation();
    }

    @HostListener('window:nativePublicationInfoAction', ['$event'])
    handleNativeInformationAction(event: CustomEvent): void {
      if (!this.isActivePublication()) return;
      const action = event?.detail?.action;
      if (action === 'details') this.OpenDetallesComponent();
      if (action === 'planet') this.converseBedrock();
      if (action === 'buy' && Number(this.publication?.price) > 0) this.PagarPublicacion();
    }

    @HostListener('window:nativePublicationInfoVisibility', ['$event'])
    handleNativeInformationVisibility(event: CustomEvent): void {
      if (!this.isActivePublication() || Capacitor.getPlatform() !== 'ios') return;
      const visible = event?.detail?.visible === true;
      if (!visible) {
        // The native surface is intentionally suspended for an action sheet;
        // do not let the Angular fallback appear underneath it.
        this.nativeInformationAvailable = true;
        return;
      }
      this.nativeInformationState = '';
      this.syncNativeInformation();
    }
    agregar_al_carrito(){

      this.request.createRequestPost('playlist_controller',{id: this.publication.id, name:'carrito', post:true})
      .then((data) => {
        console.log( 'data:', data);
        this.socialNotifications.notifyLocal(
          'Producto agregado',
          'La publicación se agregó correctamente a tu carrito.',
          { event_type: 'cart_item_added', publication_id: this.publication?.id },
        );
        Swal2.fire({
          title: 'AÑADIDO',
          text: 'LA PUBLICACIÓN HA SIDO AÑADIDA LA CARRITO',
          icon: 'success',
          showCancelButton: false,
          cancelButtonText:'Cancel',
          confirmButtonColor: 'green',
          color: '#ffffff',
          background: '#010f4e',
          position: 'top-end',
          timerProgressBar: true,
          toast: true,
          confirmButtonText: 'OK'
        }).then((result) => {
       
        });
      }).catch((error) => {
        console.error('Failed to send notification:', error);
      
      });

    }
    toggleVisibility() {
      console.log('toggleVisibility');
      this.formService.showMoreHidden= ! this.formService.showMoreHidden;
      this.formService.showMorePreferenceChanged = true;
      if(!this.formService.showMoreHidden){
        this.typeText(this.publication.description, 0.09);
        this.typeTitleText(this.publication.title, 0.09);
      }

  }
  typeText(text: string, delay: number, charLimit: number = 270) {
    let index = 0;
  
    this.publication.description = '';
    clearInterval(this.interval);
     this.interval = setInterval(() => {
      if (index < text.length && this.publication.description.length < charLimit) {
        this.publication.description += text.charAt(index);
        index++;
      } else {
        clearInterval(this.interval);
      }
    }, delay);
  }
  
  typeTitleText(text: string, delay: number, charLimit: number = 270) {
    let index = 0;
  
    this.publication.title = '';
    const interval = setInterval(() => {
      if (index < text.length && this.publication.title.length < charLimit) {
        this.publication.title += text.charAt(index);
        index++;
      } else {
        clearInterval(interval);
      }
    }, delay);
  }

  private updateChatRequestAfterBedrock(prompt: string, response: any, type: string = 'text', data?: any): Promise<any> {
    const endpoint = this.formService?.profile ? 'updateChatRequest' : 'updateChatRequest_unauth';
    let yourAIVoice;

    return this.request.createRequestPost(endpoint, {
      ID: data?.ID,
      response,
      sender_id: this.formService?.profile?.id,
      yourAIVoice,
      CharacterName: 'Alien Superintel',
      prompt,
      type,
      durationSeconds: undefined
    });
  }
  
    

  activar(){
    if(this.activador==false){
      this.activador=true
      return "Mostrar Menos"





    }else if(this.activador==true){
      this.activador=false
      return "Mostrar Menos"



    }



  }


	openCompleteInformation(){}
  
  PagarPublicacion() {

		this.modalController.create({
      component: PagosPorPublicacionComponent,
      cssClass: 'detailsInModal',
			canDismiss: true, // canDismiss enables swipe-to-close (patch forces on ALL ModalController creates)
      componentProps: {
        public:this.publication
      }
    }).then((modal) => {
      modal.present();
    }).catch((error) => {
      console.error(error);
    });
  }

  async OpenDetallesComponent() {
    await this.setNativePublicationChromeVisible(false);
    this.modalController.create({
      component: VerDetallesComponent,
      cssClass: 'detailsInModal',
			canDismiss: true, // canDismiss enables swipe-to-close (patch forces on ALL ModalController creates)
      componentProps: {
        public:this.publication
      }

    }).then(async (modal) => {
      await modal.present();
      await modal.onDidDismiss();
      this.nativeInformationState = '';
      await this.setNativePublicationChromeVisible(true);
      this.syncNativeInformation();
    }).catch((error) => {
      console.error(error);
      void this.setNativePublicationChromeVisible(true);
    });
  }

  private async setNativePublicationChromeVisible(visible: boolean): Promise<void> {
    if (Capacitor.getPlatform() !== 'ios') return;
    if (!visible) {
      // Keep the Angular surface suppressed while a native modal is covering it.
      this.nativeInformationAvailable = true;
      document.body.classList.remove('native-publication-info', 'native-publication-controls');
    }
    await Promise.all([
      NativeLiquidGlass.setRegion({ region: 'publication-info', visible }).catch(() => ({ available: false })),
      NativeLiquidGlass.setRegion({ region: 'publication-slide-nav', visible: false }).catch(() => ({ available: false })),
    ]);
    document.body.classList.remove('native-publication-controls');
  }

  converseBedrock(event?: MouseEvent) {
    if (this.planetRequestLoading) {
      return;
    }

    this.planetRequestLoading = true;
    this.postIntelPopover = {
      visible: true,
      loading: true,
      asking: false,
      // x/y no longer used — popover is now always centered via CSS
      x: 0,
      y: 0,
      title: this.publication?.title || 'Alien Superintel',
      summary: 'Alien Superintel está analizando esta publicación...',
      question: '',
    };

    const prompt = this.buildPublicationIntelMessage();
    this.request.createRequestPost('converse_bedrock', {
      message: prompt,
      characterDescription: 'Eres Alien Superintel de Laniakea. Analiza la publicacion recibida, identifica sus senales principales y responde con una lectura breve, clara y util para el feed. Usa solo los datos de la publicacion.',
      image_url: this.getPublicationImageUrl(),
      type: 'text'
    })
      .then((data) => {
        console.log('converse_bedrock response:', data);
        const response = this.normalizeBedrockResponse(data);
        this.postIntelPopover = {
          ...this.postIntelPopover,
          loading: false,
          summary: response,
        };
        this.updateChatRequestAfterBedrock(prompt, response, 'text').catch((error) => {
          console.error('Failed to update chat request after converse_bedrock:', error);
        });
      })
      .catch((error) => {
        console.error('Failed to call converse_bedrock:', error);
        this.postIntelPopover = {
          ...this.postIntelPopover,
          loading: false,
          summary: 'No se pudo generar el análisis de esta publicación en este momento.',
        };
      })
      .finally(() => {
        this.planetRequestLoading = false;
      });
  }

  closePostIntel() {
    this.postIntelPopover.visible = false;
  }

  askPostIntelQuestion(question: string) {
    const cleanQuestion = String(question || '').trim();
    if (!cleanQuestion || this.postIntelPopover.asking) {
      return;
    }

    this.postIntelPopover = {
      ...this.postIntelPopover,
      asking: true,
      question: cleanQuestion,
    };

    const prompt = `${this.buildPublicationIntelMessage()} Pregunta del usuario: "${cleanQuestion}". Responde esa pregunta usando solo los datos de la publicacion.`;
    this.request.createRequestPost('converse_bedrock', {
      message: prompt,
      characterDescription: 'Eres Alien Superintel de Laniakea. Responde preguntas sobre una publicacion de forma breve, clara y util. Usa solo los datos recibidos.',
      image_url: this.getPublicationImageUrl(),
      type: 'text'
    })
      .then((data) => {
        const response = this.normalizeBedrockResponse(data);
        this.postIntelPopover = {
          ...this.postIntelPopover,
          asking: false,
          summary: response,
        };
        this.updateChatRequestAfterBedrock(prompt, response, 'text').catch((error) => {
          console.error('Failed to update chat request after converse_bedrock:', error);
        });
      })
      .catch((error) => {
        console.error('Failed to ask converse_bedrock question:', error);
        this.postIntelPopover = {
          ...this.postIntelPopover,
          asking: false,
          summary: 'No se pudo responder la pregunta en este momento.',
        };
      });
  }

  private buildPublicationIntelMessage(): string {
    const publicationData = this.safeStringifyPublication(this.publication);
    return `Analiza esta publicacion de Laniakea y genera una respuesta breve para el usuario. Datos de la publicacion: ${publicationData}`;
  }

  private safeStringifyPublication(publication: any): string {
    try {
      return JSON.stringify(publication);
    } catch (error) {
      console.error('Failed to stringify publication for converse_bedrock:', error);
      return String(publication || '');
    }
  }

  private parseMaybeJson(data: any): any {
    if (typeof data !== 'string') {
      return data;
    }

    try {
      return JSON.parse(data);
    } catch (error) {
      return data;
    }
  }

  private normalizeBedrockResponse(data: any): string {
    const response = this.parseMaybeJson(data);
    const summary = response?.text || response?.message || response?.success?.text || response?.success?.message || response;

    if (Array.isArray(summary)) {
      return summary.join('\n');
    }

    if (typeof summary === 'string' && summary.trim()) {
      return summary.trim();
    }

    return 'Alien Superintel no encontró suficientes señales para analizar esta publicación.';
  }

  private getPublicationImageUrl(): string {
    const multimedia = this.publication?.multimediaContainer || this.publication?.multimedia || [];
    const image = Array.isArray(multimedia)
      ? multimedia.find((item) => item?.type === 'Imagen' && item?.url)
      : null;

    return image?.url || null;
  }

  private clampPopoverX(x: number): number {
    const margin = 12;
    const popoverWidth = Math.min(420, window.innerWidth - margin * 2);
    const preferredX = x > window.innerWidth * 0.62 ? x - popoverWidth - 18 : x;
    return Math.max(margin, Math.min(preferredX, window.innerWidth - popoverWidth - margin));
  }

  private clampPopoverY(y: number): number {
    const margin = 12;
    const popoverHeight = Math.min(460, window.innerHeight - margin * 2);
    const preferredY = y > window.innerHeight * 0.58 ? y - popoverHeight - 18 : y;
    return Math.max(margin, Math.min(preferredY, window.innerHeight - popoverHeight - margin));
  }


}
